<template>
  <BaseContainer v-if="html" class="mt-16">
    <div v-html="html" @click="onClick" />
  </BaseContainer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import BaseContainer from '@/components/ui/BaseContainer.vue';
import { useGeneralStore } from '@/stores/general';

const { locale } = useI18n();
const router = useRouter();
const generalStore = useGeneralStore();

// Tenant HTML set in superadmin. No fallback to other languages: an empty language shows nothing.
const html = computed(
  () => generalStore.customer().localizations?.[locale.value]?.custom_frontpage_html?.trim() ?? ''
);

// Links inside v-html are plain anchors, so route same-origin links through the router to avoid a full page reload
function onClick(event: MouseEvent) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const anchor = (event.target as Element).closest('a');
  if (!anchor || (anchor.target && anchor.target !== '_self') || anchor.hasAttribute('download')) return;

  const url = new URL(anchor.href, window.location.href);
  if (url.origin !== window.location.origin) return;

  event.preventDefault();
  router.push(url.pathname + url.search + url.hash);
}
</script>
